import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import EP1 from "../../assets/images/EP1.jpg";
import EP4 from "../../assets/images/EP4.jpg";
import EP5 from "../../assets/images/EP5.jpg";
import EP6 from "../../assets/images/EP6.jpg";
import EP7 from "../../assets/images/EP7.jpg";
import heart from "../../assets/svg/heart.svg";
import comment from "../../assets/svg/comment.svg";
import share from "../../assets/svg/share.svg";
import profile1 from "../../assets/images/profile1.png";
import styles from "./Explore.module.scss";
import axios from "../../components/Hooks/axios";

const ExploreYourMind = ({ posts }) => {
	const navigate = useNavigate();





	const [isMobile, setIsMobile] = useState(window.innerWidth < 427);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 427);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);
	return (
		<>
			<h1>Explore your mind</h1>
			{posts[0] && (
				<div className={styles.ExploreMindCont1} onClick={() => navigate(`/Post/${posts[0]?._id}`)} style={{ cursor: "pointer" }}>
					<img src={Array.isArray(posts[0]?.mediaUrl) 
						? (typeof posts[0].mediaUrl[0] === 'string' ? posts[0].mediaUrl[0] : posts[0].mediaUrl[0]?.url) 
						: posts[0]?.mediaUrl} alt="" />

					<div className={styles.ExploreMindCont1Overlay} />

					<div className={styles.MindTop}>
						<div>
							<img src={posts[0]?.userId?.ProfilePic} alt="" />
							<h5>
								<p>{posts[0]?.userId?.username}</p>
								<span>@{posts[0]?.userId?.GetstatedName}</span>
							</h5>
						</div>
						<h3>Follow</h3>
					</div>

					<div className={styles.MindBottom}>
						<p className={styles.commentText}>
							{posts[0]?.caption}
						</p>

						<div className={styles.actionContainer}>
							<div className={styles.h}>
								<img src={heart} />
								<p>{posts[0]?.likes?.length || 0}</p>
							</div>

							<div className={styles.c}>
								<img src={comment} />
								<p>{posts[0]?.comments?.length || 0}</p>
							</div>

							<div className={styles.s}>
								<img src={share} />
							</div>
						</div>
					</div>
				</div>
			)}

			<div className={styles.ExploreImageMainContainer}>
				{isMobile ? null : <h3>Recommend for you</h3>}
				<div className={styles.ExploreImageContainer}>
					{posts.slice(1).map((item, index) => (
						<img
							key={index}
							src={Array.isArray(item?.mediaUrl) 
								? (typeof item.mediaUrl[0] === 'string' ? item.mediaUrl[0] : item.mediaUrl[0]?.url) 
								: item?.mediaUrl || EP1}
							alt="post"
							onClick={() => navigate(`/Post/${item?._id}`)}
							style={{ cursor: "pointer" }}
							className={
								index === 0
									? styles.row2
									: index === 1
										? styles.row21
										: ""
							}
						/>
					))}
				</div>
			</div>
		</>
	);
};

export default ExploreYourMind;


